import { VALUE_CONSTANTS } from './constants'

export const formatValueWithPattern = (inputValue: string, pattern: string) => {
  const digits = inputValue?.replace('+1', '')?.replace(/\D/g, '')
  let formattedValue = ''
  let patternIndex = VALUE_CONSTANTS.ZERO
  let digitIndex = VALUE_CONSTANTS.ZERO

  while (digitIndex < digits.length && patternIndex < pattern.length) {
    if (pattern[patternIndex] === 'X') {
      formattedValue += digits[digitIndex]
      digitIndex++
    } else {
      formattedValue += pattern[patternIndex]
    }
    patternIndex++
  }

  return formattedValue
}

export const removePhoneMasking = (value: string) => {
  const digits = value.replace(/-/g, '')

  // Validate it's exactly 10 digits
  if (/^\d{10}$/.test(digits)) {
    return `+1 ${digits}`
  }
  return ''
}

const isDigit = (char: string): boolean => {
  return !isNaN(Number(char)) && char.trim() !== ''
}

export const formatPhoneNumber = (inputValue: string, pattern: string) => {
  const formattedInput = inputValue?.replace('+1', '')?.replace(/\D/g, '')
  if (formattedInput.length < 10) return formattedInput
  const digits = formattedInput?.slice(-10)
  let formattedValue = ''
  let patternIndex = VALUE_CONSTANTS.ZERO
  let digitIndex = VALUE_CONSTANTS.ZERO
  while (digitIndex < digits.length && patternIndex < pattern.length) {
    if (pattern[patternIndex] === 'X') {
      formattedValue += digits[digitIndex]
      digitIndex++
    } else if (isDigit(pattern[patternIndex])) {
      formattedValue += pattern[patternIndex]
      digitIndex++
    } else {
      formattedValue += pattern[patternIndex]
    }
    patternIndex++
  }

  return formattedValue
}

export const formatZipCode = (input: string) => {
  if (input.length === 9) {
    return `${input.slice(0, 5)}-${input.slice(5)}`
  } else if (input.length === 5) {
    return input
  } else {
    return input
  }
}

export const addPhoneMaskingForSave = (value: string) => {
  const digits = value?.replace('+1', '')?.replace(/\D/g, '')

  // Validate it's exactly 10 digits
  if (/^\d{10}$/.test(digits)) {
    return `+1 ${digits}`
  }
  return ''
}

export const formatCurrency = (value?: string | number) => {
  let val = softFormatCurrency(value)

  if (!val) return val
  val = val.toString()

  if (!val.includes('.')) val += '.'
  if (val.endsWith('.')) val += '00'
  return val
}
export const softFormatCurrency = (value?: string | number) => {
  if (value !== 0 && !value) return value
  const val = value?.toString().replace(/[^0-9.]/g, '')
  if (!val) return ''

  let result = formatDots(val.toString())

  result = removeExtraLeadingZeroes(result)

  const [integerPart, decimalPart] = result.split('.')
  result =
    addCommas(integerPart) +
    (decimalPart === undefined ? '' : '.') +
    (decimalPart ?? '').substring(0, 2)

  return '$' + result
}

const formatDots = (val: string) => {
  const chars: string[] = []
  let foundDot = false
  for (const c of val) {
    if (c === '.' && foundDot) continue
    if (c === '.') {
      foundDot = true
      if (chars.length === 0) chars.push('0')
    }

    chars.push(c)
  }

  return chars.join('')
}

const removeExtraLeadingZeroes = (val: string) => val.replace(/^0(?=\d)/, '')

const addCommas = (integer: string): string => {
  const withCommas: string[] = []

  for (let i = 0; i < integer.length; i++) {
    if (i > 0 && i % 3 === 0) {
      withCommas.push(',')
    }
    withCommas.push(integer[integer.length - i - 1])
  }

  return withCommas.reverse().join('')
}
